import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Grid, Card, CardContent, Typography, FormControl, InputLabel,
    Select, MenuItem, Button
} from '@mui/material';
//import axios from 'axios';
import axiosInstance from '../services/axiosInstance';

const RolesPage = ({ fetchUserActiveRole }) => {
    const navigate = useNavigate();
    const [role, setRole] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    const roles = [
        'Architect',
        'Business Analyst',
        'Developer',
        'Product Owner',
        'Project Manager',
        'Technical Lead',
        'Test Lead',
        ];

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!role) {
            setError('Please select a role.');
            return;
        }

        try {
            const token = localStorage.getItem('token');
            const userId = localStorage.getItem('userId');

            // Set role and get assigned apps from backend
            //const roleRes = await axiosInstance.post('/userinfo/set-role', { role }, {
            const roleRes = await axiosInstance.post(`/userinfo/set-role`, { role }, {
                headers: { Authorization: `Bearer ${token}` }
            });

            // Replace the token in localStorage
            const newToken = roleRes.data.token;
            if (newToken) {
                localStorage.setItem('token', newToken);
            }

            const assignedApplications = roleRes.data.assignedApplications || [];

            // Create user records for each assigned application
            for (const app of assignedApplications) {
                //await axios.post('/api/users/create-user-record', {
                await axiosInstance.post(`/users/create-user-record`, {
                    userId,
                    application: app,
                    role
                }, {
                    headers: { Authorization: `Bearer ${newToken}` }
                });
            }

            setSuccess('Role confirmed!');
            setTimeout(() => {
                fetchUserActiveRole?.();
                navigate(`/${userId}`, { replace: true });
            }, 1000);
        } catch (err) {
            console.error('Error saving role:', err);
            setError('Failed to save role or setup assessments.');
        }
    };

    return (
        <Grid container justifyContent="center" alignItems="center" sx={{ mt: 12 }}>
            <Grid item xs={12} md={6}>
                <Card sx={{ borderRadius: '25px', overflow: 'visible', zIndex: 10 }}>
                    <CardContent>
                        <Typography variant="h4" gutterBottom>Select Your Role</Typography>
                        {error && <Typography color="error">{error}</Typography>}
                        {success && <Typography color="primary">{success}</Typography>}

                        <form onSubmit={handleSubmit}>
                            <FormControl fullWidth required sx={{ my: 2 }}>
                                <InputLabel>Role</InputLabel>
                                <Select
                                    value={role}
                                    onChange={(e) => setRole(e.target.value)}
                                    variant="outlined"
                                    fullWidth
                                    MenuProps={{ PaperProps: { sx: { zIndex: 1301 } } }}
                                >
                                    {roles.map((r) => (
                                        <MenuItem key={r} value={r}>{r}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            <Button type="submit" variant="contained" color="primary" fullWidth>
                                Continue
                            </Button>
                        </form>

                        <Typography variant="h6" sx={{ mt: 4 }}>Role Descriptions</Typography>
                        <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '10px' }}>
                            <thead>
                                <tr>
                                    <th style={{ textAlign: 'left', padding: '8px', borderBottom: '1px solid #ccc' }}>Role</th>
                                    <th style={{ textAlign: 'left', padding: '8px', borderBottom: '1px solid #ccc' }}>Description</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td style={{ padding: '8px', borderBottom: '1px solid #eee' }}>Architect</td>
                                    <td style={{ padding: '8px', borderBottom: '1px solid #eee' }}>Designs and oversees the technical structure of software systems, ensuring they align with business goals, scalability, and best practices.</td>
                                </tr>
                                <tr>
                                    <td style={{ padding: '8px', borderBottom: '1px solid #eee' }}>Business Analyst</td>
                                    <td style={{ padding: '8px', borderBottom: '1px solid #eee' }}>Bridges business needs and technology by analysing requirements, identifying improvements, understanding project data, and delivering actionable insights.</td>
                                </tr>
                                <tr>
                                    <td style={{ padding: '8px', borderBottom: '1px solid #eee' }}>Developer</td>
                                    <td style={{ padding: '8px', borderBottom: '1px solid #eee' }}>Creates code, tests and deploys the Quantexa platform for end users.</td>
                                </tr>
                                <tr>
                                    <td style={{ padding: '8px', borderBottom: '1px solid #eee' }}>Product Owner</td>
                                    <td style={{ padding: '8px', borderBottom: '1px solid #eee' }}>Defines the vision and priorities on a project, managing the backlog and ensuring the development team delivers value aligned with stakeholder needs.</td>
                                </tr>
                                <tr>
                                    <td style={{ padding: '8px', borderBottom: '1px solid #eee' }}>Project Manager</td>
                                    <td style={{ padding: '8px', borderBottom: '1px solid #eee' }}>Plans, coordinates, and oversees projects, ensuring timely delivery by managing scope, resources, risks, and communication between technical teams and stakeholders.</td>
                                </tr>
                                <tr>
                                    <td style={{ padding: '8px', borderBottom: '1px solid #eee' }}>Technical Lead</td>
                                    <td style={{ padding: '8px', borderBottom: '1px solid #eee' }}>Guides the development team by setting technical direction, ensuring code quality, and facilitating collaboration to deliver successful software solutions.</td>
                                </tr>
                                <tr>
                                    <td style={{ padding: '8px', borderBottom: '1px solid #eee' }}>Test Lead</td>
                                    <td style={{ padding: '8px', borderBottom: '1px solid #eee' }}>Responsible for overseeing the planning, coordination, and execution of testing activities to ensure software quality, managing test teams, and aligning testing efforts with project goals and timelines.</td>
                                </tr>
                            </tbody>
                        </table>
                    </CardContent>
                </Card>
            </Grid>
        </Grid>
    );
};

export default RolesPage;
